// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes

// Styles
import * as css from '../../admin/MantenedorPersonal/tablaPersonal.css'

import {
    ModalTrigger,
    ModalEditarUsuario,
    ModalEliminarZona
} from './Modales.jsx'

export class TablaZonas extends React.Component {
    render(){
        return (
            <div style={{height: '70%'}}>
                <AutoSizer>
                    {({height, width}) =>
                        <Table
                            // general
                            height={height}
                            width={width}
                            // headers
                            headerHeight={30}
                            headerClassName={css.headerColumn}
                            // rows
                            rowCount={this.props.zonas.length}
                            rowGetter={({index})=> this.props.zonas[index]}
                            rowHeight={40}
                            rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)}
                        >
                            {/* INDEX */}
                            <Column
                                dataKey='#'
                                label={'#'}
                                disableSort={true}
                                cellRenderer={({rowIndex}) => rowIndex+1}
                                width={30}
                            />
                            {/* NOMBRE COMUNA*/}
                            <Column
                                dataKey={'nombreComuna'} label="Comuna"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={120}
                            />
                            {/* NUMERO DE REGION */}
                            <Column
                                dataKey='numeroRegion' label="Region"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                width={100}
                            />
                            {/* NOMBRE REGION */}
                            <Column
                                dataKey='nombreRegion' label="Nombre"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                width={270}
                            />
                            {/* VALOR ZONA */}
                            <Column
                                dataKey='valor' label="Valor"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                width={270}
                            />
                            {/* OPCION PARA EDITAR VALOR */}
                            <Column
                                dataKey='opciones'
                                label={'Editar'}
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                    <div>
                                        {/* Editar */}
                                        <BotonEditar
                                            zona={rowData.cutComuna}
                                            actualizarValor={this.props.editarValor}
                                            valorZona={rowData.valorZona}
                                        />
                                    </div>
                                )}
                                width={130}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}
const BotonEditar = ({zona, actualizarValor, captador, valorZona})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-xs btn-primary" onClick={showModal}>
                Editar Precio
                {isVisible && <ModalEditarUsuario
                    zona={zona}
                    actualizarValor={actualizarValor}
                    captador={captador}
                    hideModal={hideModal}
                    valorZona={valorZona}
                />}
            </button>
        }
    </ModalTrigger>
const BotonEliminar = ({})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-xs btn-danger" onClick={showModal} disabled>
                Eliminar Zona
                {isVisible && (<ModalEliminarZona
                />
                )}
            </button>
        }
    </ModalTrigger>    
TablaZonas.propTypes = {
    zonas: PropTypes.arrayOf(PropTypes.object).isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorCaptadoresZonas/TablaZonas.jsx